import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
  Avatar } from '@material-ui/core';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React from 'react';

const styles = theme => ({
  dialogTitleTypography: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    display: 'inline',
    fontSize: 23
  },
  dialogTitle: {
    display: 'inline-flex',
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12,
    display: 'inline-flex',
  },
  paperTable: {
    // maxHeight: '35vh'
  },
  selectTabela: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2),
    width: 200,
  },  
});
const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '0px',
        },
      },
    }
  });
class FormDialogTipoItem extends React.Component {
  state = {
    rowsSelected: [],
    codTabelaSelected: 0,
    desTabelaSelected: '',
    fetching: false,
    tiposItem: []
  }
  componentDidMount () {    
    let tiposItemExtract = [];
    this.props.tiposItem.map(res => {
      const { id, nome } = res;      
      tiposItemExtract.push(Object.values({ id, nome }));
      });      
    this.setState({tiposItem: tiposItemExtract});
  }
  handleClose = () => {
    this.props.handleClose();
  }
  handleClickSave = async () => {
    let tiposItem = [];
    let brancoAcoes = '';
    for (var i = 0; i < this.state.rowsSelected.length; i++) {
      let tipoItem = {
        codTabela: this.state.codTabelaSelected,
        desTabela: this.state.desTabelaSelected,
        codTipoItem: this.state.tiposItem[this.state.rowsSelected[i]][0],
        desTipoItem: this.state.tiposItem[this.state.rowsSelected[i]][1],
        codItemTaxa: 0,
        codItemTaxaItemTabela: 0
      }
      tiposItem.push(tipoItem);
    }
    let tiposItemExtract = [];
    tiposItem.map(res => {
      const { codTabela, desTabela, codTipoItem, desTipoItem, codItemTaxa, codItemTaxaItemTabela } = res;      
      tiposItemExtract.push(Object.values({ codTabela, desTabela, codTipoItem, desTipoItem, brancoAcoes, codItemTaxa, codItemTaxaItemTabela }));
      });      
    this.props.handleSave(tiposItemExtract);
  }  
  handleChange = event => {
    var result = this.props.tabelas.filter(obj => {
      return obj.id === event.target.value
    })
    this.setState({codTabelaSelected: event.target.value, desTabelaSelected: result[0].nome});
  }
  render () {
    const options = {
      customToolbarSelect: () => {},
      print: false,
      download: false,
      selectableRows: 'multiple',
      rowsSelected: this.state.rowsSelected,
      onRowsSelect: (rowsSelected, allRows) => {
         const selected = allRows.map(item => item.dataIndex);
         this.setState({rowsSelected: selected});
      },
      filterType: 'dropdown',
      rowsPerPageOptions: [50, 100, 500, 1000, 1500],
      rowsPerPage: 50,
      viewColumns: false,
      filter: false,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>tipo(s) selecionado(s)</Typography>
        },
      }
    };
    const columns = [
      {
        name: 'id',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Tipo de Item',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
    ];
    const { open, titulo, classes, tabelas } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          scroll='body'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleTypography}>{titulo}</Typography> 
          </DialogTitle>
          <DialogContent>
              <Paper className={classes.paperTable}>
              <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' 
              className={classes.selectTabela}
              >
                Tabela
              </InputLabel>
              <Select
                className={classes.selectTabela}
                value={this.state.codTabelaSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTabelaSelected',
                }}
              >
                {tabelas.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>  

                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={this.state.tiposItem}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </Paper>            
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.state.rowsSelected.length === 0 || this.state.codTabelaSelected === 0}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogTipoItem);
